/* Skeletons.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "@media (min-width:64rem){._2oz41v6z{border-radius:7px}._glte33sj{width:659px}._165tdlk8{height:14px}}";
const _11 = "@media (min-width:48rem){._1kkm1y44{border-radius:4px}._14b5r4m3{width:331px}._1xloftgi{height:8px}}";
const _10 = "._4t3i1crf{height:9pt}";
const _9 = "._1bsb1178{width:280px}";
const _8 = "._2rkoi2wt{border-radius:6px}";
import { media } from '@atlaskit/primitives';
import { skeletonShimmer } from '@atlaskit/theme';
const _7 = "._7hjf1yy8{animation-direction:alternate}";
const _6 = "._1pglp3kn{animation-timing-function:linear}";
const _5 = "._tip812c5{animation-iteration-count:infinite}";
const _4 = "._5sag12o8{animation-duration:1.5s}";
const _3 = "._bfhk1mnh{background-color:var(--ds-skeleton,var(--ds-skeleton,rgba(9,30,66,.04)))}";
const _2 = "._j7hq19hg{animation-name:k154l9z9}";
const _ = "@keyframes k154l9z9{0%{background-color:var(--ds-skeleton,var(--ds-skeleton,rgba(9,30,66,.04)))}to{background-color:var(--ds-skeleton-subtle,rgba(9,30,66,.08))}}";
const shimmer = skeletonShimmer();
export const Skeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Skeleton.displayName = 'Skeleton';
}
export const MatchingLabelSkeleton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _9, _10, _11, _12, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rkoi2wt _1bsb1178 _4t3i1crf _1kkm1y44 _14b5r4m3 _1xloftgi _2oz41v6z _glte33sj _165tdlk8 _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  MatchingLabelSkeleton.displayName = 'MatchingLabelSkeleton';
}